// React
import { Link } from 'react-router-dom';
// ユーティリティ
import { menu } from '../../../constants';

import sty from './PasswordReset.module.css';

const PasswordResetSuccess = ({ role }) => {
    const roleNumber = parseInt(role);
    const loginUrl = roleNumber === 1 ? menu.MNG.SIGNIN.PATH : menu.ENGINEER.SIGNIN.PATH;

    return (
        <>
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">
                        パスワード再設定完了
                    </p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
                <div className={sty['pwd-reset__pass-tit']}>
                    <p className={sty['pwd-reset__txt']}>パスワードが変更されました</p>
                    <div className="link__under-btn">
                        <Link to={loginUrl}>ログインはこちら</Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PasswordResetSuccess;
